import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import useSignIn from '../../hooks/react-query/useSignIn';
import { TextField } from '../../components/ui/TextField';
import useUserData from '../../hooks/react-query/useUserData';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../config/constants';
import { activeUserFn, getSideBarItemsFn } from '../../transactions/user/user';
import { clearStoreage, getRolesAndAcess } from '../../utils/helper';
import usePersonStore from '../../store/personStore';
import { useGetCarList } from '../../hooks/react-query/useCarData';
import { queryClient } from '../../utils/queryClient';
import { SpinnerIcon } from '../../icons';
import { useToast } from '../../components/ui/Toast/useToast';
import { useGetCompanyGroupDetails } from '../../hooks/react-query/useCompanyGroup';

const { SIDEBAR_ITEMS } = QUERY_KEYS;

const SignIn = () => {
  // const autheticationData = usePersonStore((store) => store.authData);
  const { setUserRoles, setPageAccess, setShowRetailDashBoardType } = usePersonStore();
  
  const navigate = useNavigate();

  const { toast } = useToast();
  const { hash } = useParams();

  const [hasAccess, setHasAccess] = useState(false);
  const [enableCar, setEnableCar] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn) {
      //  const localStorageData = localStorage.getItem('user-info');
      setHasAccess(true);
      // navigate('/dashboard');
    }
  }, []);

  useQuery({
    queryKey: [hash],
      queryFn: () => activeUserFn(hash),
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: hash !== undefined,
    onSuccess: (data) => {
      if (data.exceptions.length > 0) {
        toast({
          variant: 'destructive',
          description: 'Ο λογαριασμός έχει ήδη ενεργοποιηθεί',
        });
      } else {
        toast({
          variant: 'success',
          description: 'Ο λογαριασμός ενεργοποιήθηκε',
        });
      }
      navigate('/');
      },
  });

  // todo refactor signin logic
  const { mutate: loginUser, data: authData, isLoading } = useSignIn();
  useUserData(authData?.data?.access_token, true);
  const showGroupFleetAdminLandingPage = usePersonStore(
    (store) => store.showGroupFleetAdminLandingPage
  );
  useGetCarList('', 1, 6, enableCar);

  // find a better way and not call the query in component
  useQuery({
    queryKey: [SIDEBAR_ITEMS],
    queryFn: getSideBarItemsFn,
    enabled: !!authData?.data?.access_token || !!hasAccess,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    onSuccess: async (data) => {
      const { userRoles, pageAccess } = getRolesAndAcess(data.data);
      setUserRoles(userRoles);
      setPageAccess(pageAccess);
      // If user is only fleet admin or Driver then check if the car count is less the 6
      if (
        (userRoles.length === 1 &&
          (userRoles.includes('fleetadmin') || userRoles.includes('driver'))) ||
        (userRoles.length === 2 &&
          userRoles.includes('fleetadmin') &&
          userRoles.includes('driver'))
      ) {
        setEnableCar(true);
      } else {
        setShowRetailDashBoardType(false);

        navigate('/dashboard');
      }
    },
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    queryClient.clear();
    clearStoreage();
    loginUser({
      username: userName.trim(),
      password: password.trim(),
      'deposit-check': '',
    }); // error message
  };

  return (
    <div
      className="w-[100vw] flex items-center justify-center"
      style={{ height: 'calc(100vh - 72px)' }}
    >
      <form
        className="flex flex-col items-center justify-center gap-8 lg:gap-10 lg:px-44 lg:bg-white rounded-[20px] py-10"
        onSubmit={handleSubmit}
      >
        <h2 className="text-[#D4002A] md:h1">MyAvis</h2>
        <div className="flex flex-col gap-6 lg:gap-8 items-center">
          <TextField
            value={userName}
            onChange={(e) => {
              setUserName(e.target.value);
            }}
            className={
              'p-2 border border-[#A5A5A5] rounded-[8px] max-w-[550px] w-[90vw] lg:w-72 text-black'
            }
            label={'Όνομα χρήστη'}
            placeholder={''}
            id="Inputuser1"
          />
          <TextField
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            className={
              'p-2 border border-[#A5A5A5] rounded-[8px] max-w-[550px] w-[90vw] lg:w-72 text-black'
            }
            label={'Κωδικός πρόσβασης'}
            placeholder={''}
            type={'password'}
            id="InputPassword1"
          />
          <button
            type="reset"
            onClick={() => {
              navigate('/forgot-password');
            }}
          >
            <h6 className="text-[#D4002A] cursor-pointer">
            Ξέχασα τον κωδικό μου
            </h6>
          </button>
          <button
            type="submit"
            disabled={userName === '' || password === ''}
            className={
              'justify-center disabled:bg-[#A5A5A5] text-white bg-[#D4002A] px-12 py-2 rounded-[6px] w-fit max-lg:max-w-[550px] max-lg:w-[90vw] flex gap-2 items-center'
            }
          >
            {isLoading && <SpinnerIcon className="w-4 h-4 fill-white" />} Σύνδεση
          </button>
        </div>
      </form>
    </div>
  );
};

export default SignIn;
